import { TabbedPanel } from "../../ui/Tab";
import styled, { createGlobalStyle, css } from "styled-components";

export const Thumb = styled.div`
  width: 220px;
  height: 100px;
  overflow: hidden;
  border: 3px solid #ccc;
  border-radius: 6px;
`;

export const ThumbIframe = styled.iframe`
  width: 1200px;
  height: 900px;
  transform: scale(0.18);
  transform-origin: top left;
  pointer-events: none;
  border: none;
`;

export const PreviewContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const ThumbIframeWrapper = styled.div`
  display: inline-block;
  position: relative;
`;

export const CardHeader = styled.h2`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    text-align: center;
    width: 100%;
    color: ${theme.HarmonyBodyColorDefault};
    font-family: ${theme.HarmonySemanticFontFamilyAction};
    font-size: 16px;
    font-weight: ${theme.HarmonySemanticFontWeightBold};
    line-height: 1.2;
  `}
`;

export const BodyWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.HarmonySemanticSpacingXs};
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-family: ${theme.HarmonySemanticFontFamilyAction};
    font-size: ${theme.HarmonySemanticFontSizeBase};
    font-weight: ${theme.HarmonySemanticFontWeightRegular};
    line-height: ${theme.HarmonySemanticLineHeightBody};
    color: ${theme.HarmonyBodyColorDefault};
    margin: 0;
  `}
`;

export const HarmonyCardColorStyle = createGlobalStyle`
  .harmony-card--color {
    background: white !important;
    transition: background 0.2s;
  }
  .harmony-card--color.harmony-card--selected {
    background: #e3f2fd !important;
  }
  .harmony-card--color .harmony-card__header,
  .harmony-card--color [class*="card__header"],
  .harmony-card--color > div:first-child {
    display: flex !important;
    justify-content: center !important;
    text-align: center !important;
  }
`;

export const StyledTabbedPanelContent = styled(TabbedPanel.Content)`
  margin: 0 !important;
  padding: 0 !important;
  height: 100% !important;
  flex: 1 1 auto;
  min-height: 0;
  margin-top: 0 !important;
  overflow: auto !important;
`;